package com.dotdrives.repository

import com.dotdrives.client.ProfileClient
import com.dotdrives.model.Profile

interface ProfileRepository {
    suspend fun me(): Result<Profile?>

    suspend fun upsert(profile: Profile): Result<Unit>
}

class SupabaseProfileRepository(
    private val client: ProfileClient = ProfileClient(),
) : ProfileRepository {
    override suspend fun me(): Result<Profile?> =
        runCatching { client.me() }

    override suspend fun upsert(profile: Profile): Result<Unit> =
        runCatching { client.upsert(profile) }
}
